import { useState } from 'react';
import { Form, FormItem, Label, Input, Button, Title, Text, MessageStrip } from '@ui5/webcomponents-react';
import { apiBase, detectChannel } from '../platform';
import { useAuth } from '../store/auth';

export function SettingsPage() {
  const principal = useAuth(s => s.principal);
  const [base, setBase] = useState(localStorage.getItem('b1links.apiBase') ?? apiBase());
  const [saved, setSaved] = useState(false);
  return (
    <div>
      <Title level="H3">Settings</Title>
      <Form layout="S1 M1 L1 XL1" labelSpan="S12 M3 L3 XL3" style={{ marginTop: '1rem' }}>
        <FormItem labelContent={<Label>App version</Label>}><Text>{__APP_VERSION__}</Text></FormItem>
        <FormItem labelContent={<Label>Channel</Label>}><Text>{detectChannel()}</Text></FormItem>
        <FormItem labelContent={<Label>Auth mode</Label>}><Text>{principal?.mode} (SAP user: {principal?.sapUser})</Text></FormItem>
        <FormItem labelContent={<Label>Permissions</Label>}><Text>{principal?.permissions.join(', ') || '(SAP enforced)'}</Text></FormItem>
        <FormItem labelContent={<Label>API server URL</Label>}>
          <Input value={base} placeholder="https://b1links.company.com" onInput={e => setBase(e.target.value ?? '')} style={{ width: 'min(30rem,100%)' }} />
        </FormItem>
      </Form>
      <Button design="Emphasized" style={{ marginTop: '1rem' }} onClick={() => { localStorage.setItem('b1links.apiBase', base.replace(/\/$/, '')); setSaved(true); }}>Save</Button>
      {saved && <MessageStrip design="Positive" style={{ marginTop: '0.5rem' }}>Saved. Sign out and back in to apply.</MessageStrip>}
    </div>
  );
}
